import { Select as MUISelect, Box } from "@mui/material";
import { alpha, styled } from "@mui/material/styles";
import { gray } from "configs/colors";
import { rem } from "utils";

import { generateFormFieldStyles } from "../../helpers";

export const Container = styled(Box)(() => ({
  display: "block",

  // Input Label
  "& > .MuiFormLabel-root": {
    marginBottom: rem(6),
  },

  // Helper text
  ".MuiFormHelperText-root": {
    marginTop: rem(6),
    "&, &.Mui-disabled": {
      color: gray[600],
    },
  },
}));

export const SelectedIconWrapper = styled(Box)(() => ({
  display: "inline-flex",
  justifyContent: "center",
  alignItems: "center",
  marginLeft: rem(8),
  marginRight: rem(2),

  ".MuiSelect-select &": {
    display: "none",
  },
}));

export const StylesSelect = styled(MUISelect)(({ theme, color, value }) => {
  const styles = generateFormFieldStyles({ theme, color });
  const isEmpty = value === null || value === undefined;

  return {
    boxShadow: styles.normal.boxShadow,
    backgroundColor: styles.normal.backgroundColor,
    borderRadius: theme.shape.borderRadius,

    // Input
    ".MuiInputBase-input": {
      padding: `${rem(8)} ${rem(12)}`,
      minHeight: `${rem(20)} !important`,
    },

    // Fieldset
    ".MuiOutlinedInput-notchedOutline": {
      borderWidth: "1px !important",
      borderColor: styles.normal.borderColor,
      transition: theme.transitions.create([
        "border-color",
        "background-color",
        "box-shadow",
      ]),
    },

    // // Select value & placholder
    ".MuiSelect-select": {
      color: alpha(theme.palette.text.primary, isEmpty ? 0.42 : 1),
    },

    // Select icon
    ".MuiSelect-icon": {
      color: gray[500],
    },

    // Disable
    "&.Mui-disabled": {
      "& .MuiInputBase-input": {
        backgroundColor: styles.disabled.backgroundColor,
        "-webkit-text-fill-color": alpha(
          styles.disabled.color,
          isEmpty ? 0.42 : 1
        ),
      },

      "& .MuiOutlinedInput-notchedOutline": {
        borderColor: `${styles.disabled.borderColor} !important`,
      },
    },

    // Without error
    "&:not(.Mui-error)": {
      // Hover
      "&:hover .MuiOutlinedInput-notchedOutline": {
        borderColor: styles.normal.hover.borderColor,
      },
      // Focus
      "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
        borderColor: styles.normal.focus.borderColor,
        boxShadow: styles.normal.focus.boxShadow,
      },
    },

    // Error
    "&.Mui-error": {
      // Hover
      "&:hover .MuiOutlinedInput-notchedOutline": {
        borderColor: styles.error.hover.borderColor,
      },
      // Focus
      "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
        borderColor: styles.error.focus.borderColor,
        boxShadow: styles.error.focus.boxShadow,
      },
    },
  };
});
